<template>
  <q-layout view="hHh LpR lFf" class="mainLayout">
    <Header @toggle-navbar="toggleLeftDrawer" />
    <Navbar
      @toggle-navbar="toggleLeftDrawer"
      :value="leftDrawerCollapsed"
      @change="toggleLeftDrawer"
    />
    <q-page-container>
      <div class="layout-page-wrapper">
        <q-page :padding="padding" class="layout-page">
          <router-view />
        </q-page>
      </div>
    </q-page-container>
  </q-layout>
</template>

<script setup>
import Header from '@/components/layout/Header'
import Navbar from '@/components/layout/Navbar'
import { ref } from 'vue'

import { LOCALSTORAGEFIELDS } from '@/constants'
import { useAppStore } from '@/services/store/app'

const {toggleMenuDrawer} = useAppStore()

defineProps({
  padding: {
    type: Boolean,
    default: true,
  },
})
const leftDrawerCollapsed = ref(false)

function toggleLeftDrawer() {
  toggleMenuDrawer()
  leftDrawerCollapsed.value = !leftDrawerCollapsed.value
  localStorage.setItem(
    LOCALSTORAGEFIELDS.menuDrawerOpen,
    leftDrawerCollapsed.value ? '1' : '0'
  )
}
</script>

<style lang="scss">
.mainLayout {
  & > .q-page-container {
    min-width: 0;
    max-width: 100%;
  }

  & > .q-drawer-container {
    & > .q-drawer {
      width: 250px !important;
      height: calc(100vh - 80px);
      border-radius: 16px;
      top: 65px !important;
      left: 15px !important;

      @media (max-width: 991px) {
        height: unset;
        border-radius: 0;
        top: 0 !important;
        left: 0 !important;

      }
    }
  }
}
.layout-page-wrapper {
  padding: 15px;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;

  & > .layout-page {
    background-color: #fff;
    border-radius: 16px;
    overflow: clip;
    min-height: calc(100vh - 80px) !important;
  }
}
</style>
